import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { PLAY_URL, APPSTORE_URL } from "./StoreBadges";

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("mft_banner_stores_dismissed")) setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem("mft_banner_stores_dismissed", "1");
    setVisible(false);
  };

  return (
    <div className="bg-[#0A130B]" data-testid="announcement-bar">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-2 flex items-center justify-center gap-3 md:gap-4">
        <p className="hidden sm:block text-xs md:text-sm tracking-wide text-[#EAE5D9]">
          Now live on the <span className="text-[#F2C94C]">App Store</span> &amp;{" "}
          <span className="text-[#F2C94C]">Google Play</span>
        </p>
        <a
          href={APPSTORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="announcement-app-store-link"
          className="transition-transform duration-300 hover:scale-105"
        >
          <img src="/badges/app-store.svg" alt="Download on the App Store" className="h-8 md:h-9 w-auto" />
        </a>
        <a
          href={PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="announcement-google-play-link"
          className="h-8 md:h-9 overflow-hidden flex items-center transition-transform duration-300 hover:scale-105"
        >
          <img src="/badges/google-play.png" alt="Get it on Google Play" className="h-[48px] md:h-[54px] w-auto" />
        </a>
        <button
          onClick={dismiss}
          aria-label="Dismiss announcement"
          data-testid="announcement-dismiss"
          className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 text-[#EAE5D9]/60 hover:text-[#F2C94C] transition-colors duration-300"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
